import * as React from 'react';
import { AuthMotivation, CianChatError } from '@cian/newbuilding-chat-component/';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { IconCommunicationConsultant16 } from '@cian/ui-kit-design-tokens/icons';
import { useDispatch, useSelector } from 'react-redux';

import { onEntryAutorisationPopupClick } from './analytics/analytics';
import { useConsultantCianChat } from './hooks/useConsultantCianChat';
import { SendMessageButtonContainer } from './SendMessageButton';
import { getPlaceType } from './utils';
import {
  closeAutorisationMotivationConsultantCianChat,
  closeErrorMessage,
} from '../../actions/consultantCianChat/actions';
import { getGaLabel, getRegionId } from '../../selectors/analytics';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { isAutorisationPopupOpenSelector, isErrorPopupOpenedSelector } from '../../selectors/consultantChat';
import { selectNewbuildingKpnChatEnabled } from '../../selectors/consultantChat/selectNewbuildingKpnChatEnabled';
import { useApplicationContext } from '../../utils/withApplicationContext';

interface IConsultantChatButtonProps {
  isHeaderButton?: boolean;
  buttonSize?: TButtonSize;
}

export const ConsultantChatButtonContainer: React.FC<IConsultantChatButtonProps> = ({
  isHeaderButton = false,
  buttonSize = 'M',
}) => {
  const dispatch = useDispatch();
  const context = useApplicationContext();
  const { config } = context;
  const regionId = useSelector(getRegionId);
  const customLabel = useSelector(getGaLabel);
  const isKpnChatsEnabled = useSelector(selectNewbuildingKpnChatEnabled);
  const isKpnChatsFlagEnabled = config.get<boolean>('newbuilding-card-desktop-fichering-frontend.KpnChat.Enabled');
  const isAutorisationPopupOpen = useSelector(isAutorisationPopupOpenSelector);
  const isErrorPopupOpened = useSelector(isErrorPopupOpenedSelector);
  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);
  const { handleOpenChat } = useConsultantCianChat();
  const placeType = getPlaceType(isHeaderButton);

  /* istanbul ignore next */
  const onLogInClick = React.useCallback(() => {
    onEntryAutorisationPopupClick({ regionId, customPageURL: customLabel });
    handleOpenChat();
  }, [customLabel, handleOpenChat, regionId]);

  /* istanbul ignore next */
  const onLogInClose = React.useCallback(() => {
    dispatch(closeAutorisationMotivationConsultantCianChat());
  }, [dispatch]);

  /* istanbul ignore next */
  const onErrorClose = React.useCallback(() => {
    dispatch(closeErrorMessage());
  }, [dispatch]);

  if (!isKpnChatsEnabled || !isKpnChatsFlagEnabled || isBuilderChatEnabled || isHeaderButton) {
    return null;
  }

  return (
    <>
      <div>
        <SendMessageButtonContainer
          title="Написать"
          size={buttonSize}
          theme={'fill_white_primary'}
          ariaLabel="Написать консультанту"
          beforeIcon={<IconCommunicationConsultant16 color="icon-main-default" />}
          noMarginTop
          placeType={placeType}
        />
      </div>
      <AuthMotivation
        isAutorisationPopupOpened={isAutorisationPopupOpen}
        onClick={onLogInClick}
        onClose={onLogInClose}
      />
      <CianChatError onClose={onErrorClose} open={isErrorPopupOpened} />
    </>
  );
};
